import { DataTable, EmptyState, type ColumnDef } from '@vnetwork/ui/data';
import { Network } from 'lucide-react';
import { UsageMeter } from './UsageMeter';
import type { ZoneNetwork } from '@/api/opennebula/zones';

/** Virtual networks (IP pools) the zone's VMs connect to. */
interface Props {
  networks: ZoneNetwork[];
}

const clusters = (ids?: number[]): string => (Array.isArray(ids) && ids.length ? ids.join(', ') : '—');

const columns: ColumnDef<ZoneNetwork, unknown>[] = [
  { id: 'name', header: 'Name', cell: ({ row }) => <span style={{ fontWeight: 500 }}>{row.original.name}</span> },
  { id: 'vlan', header: 'VLAN ID', cell: ({ row }) => row.original.vlan_id ?? '—' },
  { id: 'clusters', header: 'Clusters', cell: ({ row }) => clusters(row.original.cluster_ids) },
  {
    id: 'leases',
    header: 'Leases',
    cell: ({ row }) => <UsageMeter used={Number(row.original.used_leases ?? 0)} total={Number(row.original.total_ips ?? 0)} />,
  },
];

export function NetworksTable({ networks }: Props) {
  return (
    <DataTable
      columns={columns}
      data={networks}
      getRowId={(n) => String(n.id)}
      emptyState={<EmptyState icon={<Network size={28} />} title="No networks" description="This zone has no virtual networks." />}
    />
  );
}
